import { Modal } from 'bootstrap';

export const PaymentModal = {
  init() {
    this.initPaymentForms();
    this.initPromoteModal();
    this.initBoostDaysSync();
    this.checkAutoOpenPromoteModal();
  },

  initPromoteModal() {
    const promoteModal = document.getElementById('promoteAdvertisement');
    if (!promoteModal) return;

    promoteModal.addEventListener('show.bs.modal', (event) => {
      const button = event.relatedTarget;
      const advertisementId = button.getAttribute('data-advertisement-id');
      const advertisementTitle = button.getAttribute('data-advertisement-title');

      // Set hidden field
      const hiddenField = document.getElementById('promo-advertisement-id');
      if (hiddenField && advertisementId) {
        hiddenField.value = advertisementId;
      }

      // Update title in modal text
      const titleElement = document.getElementById('promo-advertisement-title');
      if (titleElement && advertisementTitle) {
        titleElement.textContent = advertisementTitle;
      }
    });
  },

  initBoostDaysSync() {
    // Sync boost_days when amount radio buttons change
    const amountRadios = document.querySelectorAll('input[name="payment[amount]"]');
    const promoBoostDaysField = document.getElementById('promo-boost-days');
    const tariffBoostDaysField = document.getElementById('tariff-boost-days');

    amountRadios.forEach(radio => {
      radio.addEventListener('change', (e) => {
        const boostDays = e.target.dataset.boostDays;
        if (boostDays) {
          // Update both fields if they exist
          if (promoBoostDaysField) {
            promoBoostDaysField.value = boostDays;
          }
          if (tariffBoostDaysField) {
            tariffBoostDaysField.value = boostDays;
          }
        }
      });
    });
  },

  initPaymentForms() {
    const forms = document.querySelectorAll('#credit-payment-form, #promo-payment-form, #tariff-promotion-form');

    forms.forEach(form => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        await this.handlePaymentSubmit(form);
      });
    });
  },

  async handlePaymentSubmit(form) {
    const submitBtn = form.querySelector('input[type="submit"]');
    const originalText = submitBtn.value;
    const dangerAlert = form.querySelector('.alert--danger');

    submitBtn.disabled = true;
    submitBtn.value = 'Zpracovávám...';

    try {
      const csrfToken = document.querySelector('[name="csrf-token"]')?.content;

      const response = await fetch('/payments', {
        method: 'POST',
        body: new FormData(form),
        headers: {
          'X-CSRF-Token': csrfToken,
          'Accept': 'application/json'
        }
      });

      const data = await response.json();

      if (data.result === 'success') {
        // Close current modal if exists (for promote_advertisement case)
        const currentModal = form.closest('.modal');
        if (currentModal) {
          const modalInstance = Modal.getInstance(currentModal);
          modalInstance?.hide();
        }

        // Open vue modal with QR code
        this.openQrModal(data.payment);
      } else {
        this.showAlert(dangerAlert, data.msg || 'Nepodařilo se vytvořit platbu');
      }
    } catch (error) {
      this.showAlert(dangerAlert, 'Nastala chyba při zpracování platby');
    } finally {
      submitBtn.disabled = false;
      submitBtn.value = originalText;
    }
  },

  showAlert(element, message) {
    if (!element) return;
    element.innerHTML = message;
    element.classList.remove('d-none');
    setTimeout(() => {
      element.classList.add('d-none');
    }, 5000);
  },

  openQrModal(paymentData) {
    if (window.vueStore) {
      window.vueStore.dispatch('ModalStore/openModal', {
        id: 'paymentQrModal',
        paymentData: paymentData
      });
    } else {
      console.error('Vue store not found - PaymentQrModal cannot be opened');
    }
  },

  checkAutoOpenPromoteModal() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('openPromoteModal') === 'true') {
      const promoteModal = document.getElementById('promoteAdvertisement');
      if (promoteModal) {
        const advertisementId = urlParams.get('advertisementId');
        const advertisementTitle = urlParams.get('advertisementTitle');

        const hiddenField = document.getElementById('promo-advertisement-id');
        if (hiddenField && advertisementId) {
          hiddenField.value = advertisementId;
        }

        const titleElement = document.getElementById('promo-advertisement-title');
        if (titleElement && advertisementTitle) {
          titleElement.textContent = advertisementTitle;
        }

        const bsModal = new Modal(promoteModal);
        bsModal.show();

        const newUrl = window.location.pathname;
        window.history.replaceState({}, '', newUrl);
      }
    }
  }
};
